module.exports = __webpack_public_path__ + "static/img/编组2.33d07a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/编组2.png
// module id = TUmo
// module chunks = 1